import React from 'react';
import { sectionedPanelStyle } from '../../../../styles';
import { Spacer } from '@adserve/adserve-react-components';
import RadioGroup from '../../../../components/generic/RadioGroup';

// ASSP-7733 Add radio group with styles groupStyle and radioStyle
//
const FigureCardMultiple = ({ 
    title = '',
    figure1 = 0,
    figure2 = 0,
    figure3 = 0,
    metric = '',
    decimals = 0,
    radioItems,
    radioValue,
    radioClick
}) => {
    const figureCardStyle = {
        ...sectionedPanelStyle,
        padding: '18px 30px 10px 30px',
        height: 153 + 29, // ASSP-7703 align height with Dapyparts
        boxSizing: 'border-box',
        width: '100%'
    };

    const titleStyle = {
        fontFamily: 'Roboto',
        fontSize: 17,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        fontWeight: 'bold'
    };

    const figureStyle = {
        fontFamily: 'Roboto',
        fontSize: 18,
        color: '#FF7D00',
        textDecoration: 'none solid rgb(65, 65, 65)',
        fontWeight: 'bold'
    };

    const groupStyle = {
        boxSizing: "border-box",
        padding: "2px 0",
        width: 170,
        height: 22
    };

    const radioStyle = {
        fontFamily: 'Roboto',
        fontSize: 14,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        fontWeight: 450
    };

    const formatNumber = (n, d) => {
        return parseFloat(n).toFixed(d);
    };

    // ASSP-7703 Add margin below labels to improve appearance
    return (
        <div style={figureCardStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <span style={titleStyle}>{title}</span>
                </div>
                {radioItems && radioItems.length 
                    ? (<RadioGroup 
                            items={radioItems}
                            value={radioValue}
                            onClick={radioClick}
                            style={groupStyle}
                            radioStyle={radioStyle}
                            unboxed
                      />)
                    : (<div style={groupStyle}>&nbsp;</div>)
                }
            </div>

            <Spacer width={0} height={37} />

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <div style={{ fontSize: 12, width: 40, marginBottom: 5 }}>Total Delivered</div>
                    <span style={figureStyle}>{`${formatNumber(figure1, decimals)} ${metric}`}</span>
                </div>
                <div>
                    <div style={{ fontSize: 12, width: 40, marginBottom: 5 }}>Total Booked</div>
                    <span style={figureStyle}>{`${formatNumber(figure2, decimals)} ${metric}`}</span>
                </div>
                <div>
                    <div style={{ fontSize: 12, width: 40, marginBottom: 5 }}>Total Scheduled</div>
                    <span style={figureStyle}>{`${formatNumber(figure3, decimals)} ${metric}`}</span>
                </div>
                <div>
                    <div style={{ fontSize: 12, width: 40, marginBottom: 5 }}>Estimated Completion</div>
                    <span style={figureStyle}>{`${formatNumber(
                        (parseFloat(figure3) / parseFloat(figure2)) * 100,
                        1
                    )} %`}</span>
                </div>
            </div>
        </div>
    );
};

export default FigureCardMultiple;
